import BaseModule from "~/vuex/modules/base-module";

let Passengers = {...BaseModule};

Passengers.state = function () {
    let state = BaseModule.state();

    //state.endpoints['all'] = '/api/...';

    state.lastDate = null;
    state.sort = {};


    return state;
};


export default Passengers;